import {
  Box,
  Drawer,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import CloseIcon from '@mui/icons-material/Close'
import { VISIT_STATUS_FINISHED } from '../opd/components/devices/Constant'

import { useAppSelector } from '../../app/hooks'

// import { useNavigate, useParams } from 'react-router-dom'
import { selectPatientData } from '../opd/OpdPatientSlice'

// import { toast } from 'react-toastify'
import OpdTricog from './OpdTricog'
import PFTScreening from './PFTScreening'

// import { useWebSocket } from './Socket'

const styles = () => ({
  deviceTab: {
    textTransform: 'capitalize',
  },
  drawerHeading: {
    background: '#183f7c',
    color: '#ffffff',
    position: 'sticky',
    top: 0,
    zIndex: 9999,
  },
  nextBtn: {
    background: '#4682b4',
    textTransform: 'capitalize',
  },
})

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

interface OpdDevicesProps {
  appointmentData?: any
}

const OpdDevices: React.FC<OpdDevicesProps> = ({ appointmentData }) => {
  // const { id }: any = useParams()
  // const dispatch = useAppDispatch()
  // const navigate = useNavigate()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const useMuiResponsiveWidth = () => {
    const theme = useTheme()

    const isXs = useMediaQuery(theme.breakpoints.only('xs'))
    const isSm = useMediaQuery(theme.breakpoints.only('sm'))
    const isMd = useMediaQuery(theme.breakpoints.only('md'))
    const isLg = useMediaQuery(theme.breakpoints.only('lg'))
    const isXl = useMediaQuery(theme.breakpoints.only('xl'))

    if (isXs) return '95%'
    if (isSm) return '85%'
    if (isMd) return '60%'
    if (isLg) return '55%'
    if (isXl) return '45%'

    return '50%'
  }

  const patient = useAppSelector(selectPatientData)

  const [value, setValue] = React.useState(0)
  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [selectedVital, setSelectedVital] = React.useState('')

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const handleDrawerClose = () => {
    setOpenDrawer(false)
    setSelectedVital('')
  }

  // Merge Redux patient data with appointmentData prop
  // appointmentData prop takes precedence for visitId/uhid since for camp visits
  // it is the ground truth passed at click time; Redux may hold stale values.
  const mergedAppointmentData = React.useMemo(() => {
    return {
      ...appointmentData,
      uhid: appointmentData?.uhid || patient?.uhid || patient?.patientUhid,
      visitId: appointmentData?.visitId || patient?.visitId,
      campId: appointmentData?.campId,
      patientUhid:
        appointmentData?.patientUhid || patient?.uhid || patient?.patientUhid,
    }
  }, [appointmentData, patient])

  return (
    <Box width={'97%'} height={'100%'} pl={2} pt={2}>
      <Drawer
        anchor='right'
        open={openDrawer}
        onClose={handleDrawerClose}
        PaperProps={{
          style: {
            width: useMuiResponsiveWidth(),
          },
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            pl={1}
            pr={1}
            className={classes?.drawerHeading}
          >
            <Typography fontSize={'17px'} fontWeight={600}>
              {selectedVital}
            </Typography>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon htmlColor='#ffffff' />
            </IconButton>
          </Grid>
        </Grid>
      </Drawer>
      {patient?.visitStatus !== VISIT_STATUS_FINISHED ? (
        <>
          <Box borderBottom={1} borderColor='divider'>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label='basic tabs example'
            >
              <Tab
                label='Tricog'
                {...a11yProps(0)}
                className={classes?.deviceTab}
              />
              <Tab
                label='PFT'
                {...a11yProps(1)}
                className={classes?.deviceTab}
              />
              {/* )} */}
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <OpdTricog appointmentData={mergedAppointmentData} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <PFTScreening appointmentData={mergedAppointmentData} />
          </CustomTabPanel>
        </>
      ) : (
        <Typography>
          Devices data cannot be viewed for completed visit
        </Typography>
      )}
    </Box>
  )
}

export default OpdDevices
